(() => {
  function init(root = document) {
    const editorial = root.querySelector('.ffn-route--politicas .ffn-editorial');
    if (!editorial || editorial.querySelector('.ffn-policy-toc')) return;
    const headings = [...editorial.querySelectorAll('.rte h2')];
    if (!headings.length) return;
    const nav = document.createElement('nav');
    nav.className = 'ffn-policy-toc'; const lang=(document.documentElement.lang||'pt').toLowerCase(); nav.setAttribute('aria-label', lang.startsWith('de')?'Auf dieser Seite':lang.startsWith('en')?'On this page':'Nesta página');
    headings.forEach((heading, index) => {
      heading.id = heading.id || `ffn-policy-${index + 1}`;
      const link = document.createElement('a'); link.href = `#${heading.id}`; link.textContent = heading.textContent; nav.append(link);
    });
    editorial.querySelector('aside').append(nav);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
